<div class="push-destinations-container">
  <mat-card class="push-destinations-card">
    <!-- Loading -->
    @if (loading()) {
      <div class="loading-container">
        <mat-spinner diameter="32"></mat-spinner>
      </div>
    }

    <!-- Empty State -->
    @if (!loading() && displayDestinations().length === 0) {
      <div class="empty-state">
        <mat-icon class="empty-icon">notifications_off</mat-icon>
        <h3 class="empty-title">No push destinations configured</h3>
        <p class="empty-description">
          Set up push destinations to receive notifications when routines
          complete, fail, or need review.
        </p>
        <button mat-stroked-button color="primary" (click)="addDestination()">
          Add Your First Destination
        </button>
      </div>
    }

    <!-- Table -->
    @if (!loading() && displayDestinations().length > 0) {
      <div class="destinations-table-wrapper">
        <div class="destinations-table-header">
          <div class="col name-col">Name</div>
          <div class="col service-col">Service</div>
          <div class="col events-col">Events</div>
          <div class="col scope-col">Scope</div>
          <div class="col status-col">Status</div>
          <div class="col actions-col"></div>
        </div>
        <div class="destinations-table-body">
          @for (dest of displayDestinations(); track dest.destinationId) {
            <div class="destinations-table-row">
              <!-- Name -->
              <div class="col name-col">
                <span class="name-text">{{ dest.name }}</span>
              </div>
              <!-- Service -->
              <div class="col service-col">
                <div class="service-badge service-{{ dest.serviceType }}">
                  <mat-icon class="service-icon">{{ dest.serviceIcon }}</mat-icon>
                  <span>{{ dest.serviceLabel }}</span>
                </div>
              </div>
              <!-- Events -->
              <div class="col events-col">
                <div class="event-chips">
                  @for (chip of dest.eventChips; track chip.type) {
                    <span class="event-chip event-{{ chip.type }}">
                      {{ chip.label }}
                    </span>
                  }
                </div>
              </div>
              <!-- Scope -->
              <div class="col scope-col">
                <span class="scope-text">{{ dest.scopeLabel }}</span>
              </div>
              <!-- Status -->
              <div class="col status-col">
                <span
                  class="status-badge"
                  [class.enabled]="dest.enabled"
                  [class.disabled]="!dest.enabled"
                >
                  <span class="status-dot"></span>
                  {{ dest.statusLabel }}
                </span>
              </div>
              <!-- Actions -->
              <div class="col actions-col">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="destMenu"
                  class="action-menu-button"
                  [attr.aria-label]="'Actions for ' + dest.name"
                >
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #destMenu="matMenu">
                  <button mat-menu-item (click)="onActionMenu(dest, 'edit')">
                    <mat-icon>edit</mat-icon>
                    <span>Edit</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="onActionMenu(dest, 'test')"
                    [disabled]="testingDestinationId() === dest.destinationId"
                  >
                    <mat-icon>{{
                      testingDestinationId() === dest.destinationId
                        ? "hourglass_empty"
                        : "send"
                    }}</mat-icon>
                    <span>{{
                      testingDestinationId() === dest.destinationId
                        ? "Sending..."
                        : "Send Test"
                    }}</span>
                  </button>
                  <button mat-menu-item (click)="onActionMenu(dest, 'toggle')">
                    <mat-icon>{{
                      dest.enabled ? "pause_circle" : "play_circle"
                    }}</mat-icon>
                    <span>{{ dest.enabled ? "Disable" : "Enable" }}</span>
                  </button>
                  <mat-divider></mat-divider>
                  <button
                    mat-menu-item
                    class="menu-item-delete"
                    (click)="onActionMenu(dest, 'delete')"
                  >
                    <mat-icon>delete</mat-icon>
                    <span>Delete</span>
                  </button>
                </mat-menu>
              </div>
              <!-- Test Result Feedback -->
              @if (
                testResult() && testResult()!.destinationId === dest.destinationId
              ) {
                <div
                  class="test-result-row"
                  [class.test-success]="testResult()!.success"
                  [class.test-error]="!testResult()!.success"
                >
                  <mat-icon>{{
                    testResult()!.success ? "check_circle" : "error"
                  }}</mat-icon>
                  <span>{{ testResult()!.message }}</span>
                  <button
                    mat-icon-button
                    class="dismiss-test"
                    (click)="clearTestResult()"
                    aria-label="Dismiss"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </mat-card>
</div>
